module.exports = __webpack_public_path__ + "img/case_he_fei_xin.cea7cfa2.png";